export default __webpack_public_path__ + "static/media/Pharmecis.440f712b.svg";